import React from 'react'
import styled from 'styled-components'
import { Box } from 'grommet'
import { Contract as ContractIcon, Expand as ExpandIcon } from 'grommet-icons'
import { isMobileOnly, isSafari, isTablet, isIOS } from 'react-device-detect'

import InlineTooltipButton from './InlineTooltipButton' //use self make tip as mobile view not appear, this self make not function well in mobile
// import TooltipButton from './TooltipButton'
import { device } from '../../theme/device'

const FullScreenButtonBox = styled(Box)`
  position: absolute;
  bottom: ${props => (!props.active ? props.position : '1.5rem')};
  right: ${props => (!props.active ? props.position : '1.5rem')};

  @media (max-width: 645px) {
    display: none;
  }
`

const Contract = styled(ContractIcon)`
  width: 18px;
  height: 18px;
  @media ${device.medium} {
    width: 14px;
    height: 14px;
  }
`

const Expand = styled(ExpandIcon)`
  width: 18px;
  height: 18px;
  @media ${device.medium} {
    width: 14px;
    height: 14px;
  }
`

const FullScreenButton = ({ handleFullScreen, position = '1.5rem' }) => {
  if (isMobileOnly) return null
  if (isTablet && isIOS && !isSafari) return null
  return (
    <FullScreenButtonBox active={handleFullScreen.active} position={position}>
      <InlineTooltipButton
        icon={
          handleFullScreen.active ? (
            <Contract color="iconDark" />
          ) : (
            <Expand color="iconDark" />
          )
        }
        clicked={
          handleFullScreen.active
            ? handleFullScreen.exit
            : handleFullScreen.enter
        }
        message={handleFullScreen.active ? 'Exit Full Screen' : 'Full Screen'}
        position="left"
        color="iconDark"
      />
    </FullScreenButtonBox>
  )
}

export default FullScreenButton
